import makeStyles from '@mui/styles/makeStyles';
import cx from 'classnames';
import React from 'react';

const useStyles = makeStyles({
  learn: {
    display: 'inline-block',
  },
});

export default function FaqLink({
  className,
  url,
  disable = false,
  title = 'Need help? Check out our FAQ →',
}: any) {
  const s = useStyles();

  return (
    !disable && (
      <a
        className={cx(s.learn, className)}
        style={{ marginTop: 10 }}
        target="_blank"
        rel="noreferrer"
        href={url}
      >
        {title}
      </a>
    )
  );
}
